import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "../../lib/api";
import { useStore } from "../../context/StoreContext";
import HomeSections from "../../components/storefront/HomeSections";
import PromoPopup from "../../components/storefront/PromoPopup";
import { setMeta } from "../../lib/seo";

export default function Home() {
  const { settings } = useStore();
  const [sections, setSections] = useState(null);
  const [seo, setSeo] = useState(null);
  const [homeData, setHomeData] = useState(null);

  useEffect(() => {
    api.get("/home/sections").then(({ data }) => { setSections(data.sections || []); setSeo(data.seo); }).catch(() => setSections([]));
    api.get("/home").then(({ data }) => setHomeData(data)).catch(() => {});
  }, []);

  useEffect(() => {
    setMeta("description", seo?.seo_description || settings?.seo_description || "");
  }, [seo, settings]);

  return (
    <div>
      <Helmet>
        <title>{seo?.seo_title || settings?.seo_title || "BIGELDİ"}</title>
        <link rel="canonical" href={window.location.origin + "/"} />
        {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
        {seo?.og_description && <meta property="og:description" content={seo.og_description} />}
        {seo?.og_image && <meta property="og:image" content={seo.og_image} />}
      </Helmet>
      {sections === null ? (
        <div className="h-[70vh] bg-[#121214] animate-pulse-soft" />
      ) : (
        <HomeSections sections={sections} homeData={homeData} />
      )}
      <PromoPopup />
    </div>
  );
}
